
let clearSignUp = () => {
	let email = document.getElementById("signup-email")
	let username = document.getElementById("signup-username")
	let password = document.getElementById("signup-password")
	let confirmPassword = document.getElementById("signup-confirmPassword")
	let mobile = document.getElementById("signup-mobile")
	let signupText = document.getElementById("signup-submit-text")
	email.value = ""
	username.value = ""
	password.value = ""
	confirmPassword.value = ""
	mobile.value = ""
	signupText.innerText = "Register"
}

let clearSignIn = () => {
	let loginEmail = document.getElementById("login-email")
	let loginPassword = document.getElementById("login-password")
	let loginBtnText = document.getElementById("login-submit-text")
	let termsCheckox=document.getElementById("terms-vms-policy")
	let newsLetterCheckbox=document.getElementById("newsLetter")
	loginEmail.value = ""
	loginPassword.value = ""
	loginBtnText.innerText = "LogIn"
	termsCheckox.checked=false
	newsLetterCheckbox.checked=false


}

let signUpFun = () => {
	document.getElementById("signinToggle").classList.remove("active")

	document.getElementById("signupToggle").classList.add("active")

	document.getElementById("signinForm").style.display = "none"
	document.getElementById("signupForm").style.display = "block"
	const emailError = document.querySelector(".email.error");
	const passwordError = document.querySelector(".password.error");
	const loginError = document.getElementById("signinFormError")
	emailError.textContent = "";
	passwordError.textContent = "";
	loginError.textContent = "";
	clearSignIn()
}

let signInFun = () => {
	document.getElementById("signinToggle").classList.add("active")

	document.getElementById("signupToggle").classList.remove("active")
	document.getElementById("signupForm").style.display = "none"

	document.getElementById("signinForm").style.display = "block"
	const usernameError = document.getElementById("usernameError");
	const emailError = document.getElementById("signupEmailError");
	const mobileError = document.getElementById("mobileError");
	const passwordError = document.getElementById("signupPasswordError");
	const confirmPassError = document.getElementById("conFirmPassError");
	const signupFormError = document.getElementById("signupFormError");
	usernameError.textContent = "";
	emailError.textContent = "";
	mobileError.textContent = "";
	passwordError.textContent = "";
	confirmPassError.textContent = "";
	signupFormError.textContent = "";
	clearSignUp()
}


document.getElementById("signinToggle").addEventListener("click", () => {
	signInFun()
})
document.getElementById("signup-exisitingUser").addEventListener("click", () => {
	signInFun()
})
document.getElementById("signupToggle").addEventListener("click", () => {
	signUpFun()
})

document.getElementById("registerHere").addEventListener("click", () => {
	signUpFun()
})


document.addEventListener("DOMContentLoaded", function (event) {
	function OTPInput() {
		const inputs = document.querySelectorAll("#otp > *[id]");
		for (let i = 0; i < inputs.length; i++) {
			inputs[i].addEventListener("keydown", function (event) {
				if (event.key === "Backspace") {
					inputs[i].value = "";
					if (i !== 0) inputs[i - 1].focus();
					return false;
				}
				 if (event.key>=0 && event.key<=9) {
					inputs[i].value = event.key;
					if (i !== inputs.length - 1) {
						inputs[i + 1].focus();
						inputs[i + 1].value=""
						event.preventDefault();
						return false;
					}else{
						event.preventDefault();
						return false;
					}
				} else{
					event.preventDefault();
					return false;
				}
				return false;
			});
		}
		const Resetinputs = document.querySelectorAll("#Resetotp > *[id]");
		for (let i = 0; i < Resetinputs.length; i++) {
			Resetinputs[i].addEventListener("keydown", function (event) {

				if (event.key === "Backspace") {
					Resetinputs[i].value = "";
					if (i !== 0) Resetinputs[i - 1].focus();
					return false;
				}
				 if (event.key>=0 && event.key<=9) {
					Resetinputs[i].value = event.key;
					if (i !== Resetinputs.length - 1) {
						Resetinputs[i + 1].focus();
						Resetinputs[i + 1].value=""
						event.preventDefault();
						return false;
					}else{
						event.preventDefault();
						return false;
					}
				} else{
					event.preventDefault();
					return false;
				}
				return false;
			});
		}
	}
	OTPInput();
});




// document.getElementById("closeSignUpInPopup").addEventListener("click",()=>{
// 	signInFun()
// 	signUpFun()

// 	document.getElementById("signUpInPopup").style.display = "none"
// 	document.getElementById("signinToggle").classList.add("active")
// 	document.getElementById("signupToggle").classList.remove("active")
// 	document.getElementById("signupForm").style.display = "none"
// 	document.getElementById("signinForm").style.display = "block"

// })

document.getElementById("otpBackImg").addEventListener("click", () => {
	const otpError = document.getElementById("otpError");
	const otp1 = document.getElementById("firstOTP");
	const otp2 = document.getElementById("secondOTP");
	const otp3 = document.getElementById("thirdOTP");
	const otp4 = document.getElementById("fourthOTP");
	const otp5 = document.getElementById("fifthOTP");
	const otp6 = document.getElementById("sixthOTP");
	otpError.textContent = "";
	otp1.value = otp2.value = otp3.value = otp4.value = otp5.value = otp6.value = null
	document.getElementById("otp-form-text").setAttribute('data-email', null)
	document.getElementById("OtpPopup").style.display = "none"
	const loginText = document.getElementById("verify-otp-text");
	loginText.innerText = "Verify" 
	document.getElementById("SignInCard").style.display="block"
})
document.getElementById("ResetBackImg").addEventListener("click", () => {
	const ResetOtpError = document.getElementById("ResetError");
	const resetPasswordError = document.getElementById("resetPasswordError");
	const ResetOtp1 = document.getElementById("firstOTP");
	const ResetOtp2 = document.getElementById("secondOTP");
	const ResetOtp3 = document.getElementById("thirdOTP");
	const ResetOtp4 = document.getElementById("fourthOTP");
	const ResetOtp5 = document.getElementById("fifthOTP");
	const ResetOtp6 = document.getElementById("sixthOTP");
	ResetOtpError.textContent = "";
	resetPasswordError.textContent = "";
	ResetOtp1.value = ResetOtp2.value = ResetOtp3.value = ResetOtp4.value = ResetOtp5.value = ResetOtp6.value = null
	document.getElementById("Reset-form-text").removeAttribute('data-email')
	document.getElementById("ResetPopup").style.display = "none"
	const loginText = document.getElementById("reset-login-otp-text");
	loginText.innerText = "Change" 
	document.getElementById("SignInCard").style.display="block"
})
